export default "__VITE_ASSET__9c00986e__"